import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { HelpTextService } from '../../services/help-text.service';
import { CustomDialogSettings } from '../../model/CustomDialogSettings';
import { EditHelpTextDialogComponent } from '../edit-help-text-dialog/edit-help-text-dialog.component';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { CustomDialogService } from '../../services/custom-dialog.service';
import { Abilities } from '../../model/Abilities';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-show-help-text',
  templateUrl: './show-help-text.component.html',
  styleUrls: ['./show-help-text.component.scss']
})
export class ShowHelpTextComponent implements OnInit, OnChanges, OnDestroy {

  constructor(
    private helpTextService: HelpTextService,
    private customDialogService: CustomDialogService,
    private authService: AuthService,
    private domSanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    this.hasEditHelpTextAbility = this.authService.hasAbility(Abilities.CanEditHelpText);
  }

    hasEditHelpTextAbility = false;
    @ViewChild("helpTextDialog", { read: ViewContainerRef })
    public containerRef!: ViewContainerRef;


  @Input() code = '';

  isOpen = false;
  isLoading = false;
  description = '';
  descriptionHtml: SafeHtml = '';
  showErrorMessage = false;

  private helpTextSubscription?: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['code'] && this.code) {
      this.isOpen = false;
      this.description = '';
      this.descriptionHtml = '';
      this.showErrorMessage = false;
      this.helpTextSubscription?.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.helpTextSubscription?.unsubscribe();
  }

  toggle(): void {
    this.isOpen = !this.isOpen;

    if (this.isOpen && this.code && !this.description && !this.isLoading) {
      this.loadHelpText();
    }
  }

  edit(): void {
    const dialogSettings: CustomDialogSettings = {
      content: EditHelpTextDialogComponent,
      appendTo: this.containerRef,
      minWidth: "60vw",
      minHeight: "60vh",
      maxWidth: "60vw",
      maxHeight: "60vh",
      dialogInputs: {
        code: this.code,
      },
      resultCallback: (r: DialogResult) => {
        if ((r as { text?: string })?.text === "OK") {
         this.toggle();
        }
      }
    }
    
    this.customDialogService.showDialog(dialogSettings);
  }

  close(): void {
    this.isOpen = false;
  }

  private loadHelpText(): void {
    this.helpTextSubscription?.unsubscribe();

    this.isLoading = true;
    this.showErrorMessage = false;

    this.helpTextSubscription = this.helpTextService.getHelpText(this.code).subscribe({
      next: (helpText) => {
        this.description = helpText?.description || '';
        this.descriptionHtml = this.domSanitizer.bypassSecurityTrustHtml(this.description);
        this.isLoading = false;
      },
      error: () => {
        this.description = '';
        this.descriptionHtml = '';
        this.showErrorMessage = true;
        this.isLoading = false;
      },
    });
  }

}
